module.exports = __webpack_public_path__ + "static/media/chevy-kaeo-martinez.bd89d7a9.md";